import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { PusherService } from './services/pusher.service';
import { VersionService } from 'src/app/services/version.service';
import { ApiService } from './services/api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public loading: boolean = false;
  public user: any = null;

  constructor(
    private _api: ApiService,
    public _router: Router,
    private _version: VersionService
  ) {
    console.log('AppComponent constructor');
    this.loaderOnRouteChange();
  }

  async ngOnInit(): Promise<void> {
    this._version.watch();

    console.log(this._version.full_version);
    console.log('AppComponent ngOnInit');
    this.user = await this._api.getUser();
    // this._pusher.addDeviceInterest(this.user.pusher_interests);
    // let resul = this._pusher.NotificationsObservable;
    // console.log('Este es el mensjae re getWorker', resul);
  }

  ngOnDestroy(): void {
    console.log('AppComponent ngOnDestroy');
  }

  public loaderOnRouteChange(): void {
    console.log('AppComponent loaderOnRouteChange');
    this._router.events.subscribe((val: any) => {
      if (val instanceof NavigationStart) {
        this.loading = true;
      }

      if (val instanceof NavigationEnd) {
        this.loading = false;
      }
    });
  }
}
